import { InputComponent } from "components/components/Component";
import { SimpleInputBaseDefinition, SimpleInputBaseComponent } from "components/input/baseInputDefinition";
import { LabelElement } from "components/components/label/labelElement";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import template from "./code.hbs";
import { CodeInputElement } from "./codeElement";

export class CodeInput extends SimpleInputBaseComponent<CodeInputDefinition> implements InputComponent {

    public readonly componentType: string = "codeInput";

    private element: CodeInputElement;

    constructor(schema: CodeInputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        ComponentActionHelper.register(this);
        return this.view;
    }

    public renderTemplate(): Element {
        return super.renderTemplate(template);
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-code-input");

        const enableKeyUpFinishedTyping = (this.definition.disableFinishedTyping !== true);

        this.genericBindEvents(this.element, enableKeyUpFinishedTyping);
    }

    public getValue(): number {
        return this.element.data;
    }

    public value(v: number) {
        if ((v == null) || ((v as unknown) === "")) {
            this.element.data = null;
        } else {
            this.element.data = v;
        }
    }

    public setReadOnly(ro: boolean) {
        this.element.readOnly = ro;
    }

    public setRequired(required: boolean) {
        let elementLabel = this.view.querySelector("s6-input-label");
        if (elementLabel != null) {
            (elementLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }
}

export interface CodeInputDefinition extends SimpleInputBaseDefinition {
    maxlength?: number;
    disableFinishedTyping?: boolean;
}
